var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import React, { useState } from 'react';
import { AiOutlineLoading } from 'react-icons/ai';
import { IoMdClose } from 'react-icons/io';
import { FixedSizeList } from 'react-window';
import toast from 'react-hot-toast';
import { EntityPermissionsType, TagType } from '@common/api';
import { useLanguage } from '@base/LanguageProvider';
import FSButton from '@components/FSButton';
import DeleteTagModal from '@shared/finder/modals/DeleteTag';
import TagModal from '@shared/finder/modals/EditTag';
import ShareModal from '@shared/finder/modals/ShareModal';
import * as FarseerIcons from '@shared/icons/icons';
import SearchInput from '@shared/input/SearchInput';
import Manager from '@shared/modal/Manager';
import Modal from '@shared/modal/Modal';
import ModalHeader from '@shared/modal/ModalHeader';
import { startGlobalLoading, stopGlobalLoading } from '@shared/loading/globalLoading';
import { downloadFileViaBlob, farseerFilesApi } from '@data/rest/api';
import { useTagContext } from '@data/tag/tagContext';
import { useTableTagRelationsActions } from '@data/tag/tagRelationActions';
import { CustomColumnType, isDimensionTagJsonData, isInternalTag, } from '@data/tag/types';
import { ModalBody, ModalFooterStyled } from '@styled/Modal';
import { TagEditorColumnType } from './useTagTable';
import { calculateTagPerms } from './permissions';
import { getTagTypeName } from '../../../data/tag/tagUtil';
export var customColumnIconMap = (_a = {},
    _a[CustomColumnType.TEXT] = FarseerIcons.Text,
    _a[CustomColumnType.NUMBER] = FarseerIcons.NumberIcon,
    _a[CustomColumnType.FILE] = FarseerIcons.Flow,
    _a[CustomColumnType.DATE] = FarseerIcons.Date,
    _a);
function TagConnectionModalForm(_a) {
    var e_1, _b;
    var _this = this;
    var _c;
    var targetRow = _a.targetRow, setLoading = _a.setLoading;
    var L = useLanguage().L;
    var tagData = useTagContext().tagData;
    var _d = __read(useState(''), 2), searchString = _d[0], setSearchString = _d[1];
    var _e = __read(useState(), 2), searchedTagIds = _e[0], setSearchedTagIds = _e[1];
    var searchEnabled = searchedTagIds !== undefined;
    var rowTag = tagData.tagById[targetRow.id];
    var rowTagParentTag = rowTag && rowTag.ParentId !== null ? tagData.tagById[rowTag.ParentId] : undefined;
    var tableTagId = rowTagParentTag && rowTagParentTag.type === TagType.Table ? rowTagParentTag.id : undefined;
    var relations = tableTagId !== undefined ? (_c = tagData.relationsByTableTagId[tableTagId]) !== null && _c !== void 0 ? _c : [] : [];
    var tags = [];
    var alreadyConnectedTagIds = [];
    relations.forEach(function (relation) {
        var options = tagData.tagsByParentId[relation.connectedTableTagId];
        options === null || options === void 0 ? void 0 : options.forEach(function (option) {
            tags.push(option);
        });
        relation.connections.forEach(function (c) {
            if (c.dimensionTagId === (rowTag === null || rowTag === void 0 ? void 0 : rowTag.id)) {
                alreadyConnectedTagIds.push(c.connectedDimensionTagId);
            }
        });
    });
    var _f = useTableTagRelationsActions(), addTableRelationConnectedTag = _f.addTableRelationConnectedTag, removeTableRelationConnectedTag = _f.removeTableRelationConnectedTag;
    function onSearchHandler(value) {
        setSearchString(value);
        setSearchedTagIds(tagData.searchTagsAndReturnIds(value));
    }
    var connected = [];
    var notConnected = [];
    var _loop_1 = function (tag) {
        if ((searchEnabled && !(searchedTagIds === null || searchedTagIds === void 0 ? void 0 : searchedTagIds.has(tag.id))) || isInternalTag(tag)) {
            return "continue";
        }
        var isConnected = alreadyConnectedTagIds === null || alreadyConnectedTagIds === void 0 ? void 0 : alreadyConnectedTagIds.some(function (id) { return id === tag.id; });
        isConnected ? connected.push(__assign(__assign({}, tag), { connected: true })) : notConnected.push(__assign(__assign({}, tag), { connected: false }));
    };
    try {
        for (var _g = __values(tags), _h = _g.next(); !_h.done; _h = _g.next()) {
            var tag = _h.value;
            _loop_1(tag);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var filteredTags = __spreadArray(__spreadArray([], __read(connected), false), __read(notConnected), false);
    var renderRow = function (_a) {
        var index = _a.index, style = _a.style;
        var tag = filteredTags[index];
        var isConnected = filteredTags[index].connected;
        return (React.createElement("div", { style: style, className: "row-wrapper", key: tag.name },
            React.createElement("div", { className: "column-wrapper" },
                React.createElement("h5", null, tag.name)),
            React.createElement("div", { className: "column-wrapper" },
                React.createElement(FSButton, { "$type": "tertiary", "$color": isConnected ? 'error' : 'primary', title: L(isConnected ? 'Disconnect' : 'Connect'), onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        var relation, _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    if (setLoading !== undefined) {
                                        setLoading(true);
                                    }
                                    relation = relations.find(function (relation) { return relation.connectedTableTagId === tag.ParentId; });
                                    if (!(rowTag !== undefined && relation !== undefined)) return [3 /*break*/, 5];
                                    if (!isConnected) return [3 /*break*/, 2];
                                    return [4 /*yield*/, removeTableRelationConnectedTag(relation.id, rowTag.id, tag.id)];
                                case 1:
                                    _a = _b.sent();
                                    return [3 /*break*/, 4];
                                case 2: return [4 /*yield*/, addTableRelationConnectedTag(relation.id, rowTag.id, tag.id)];
                                case 3:
                                    _a = _b.sent();
                                    _b.label = 4;
                                case 4:
                                    _a;
                                    _b.label = 5;
                                case 5:
                                    if (setLoading !== undefined) {
                                        setLoading(false);
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); } }))));
    };
    return (React.createElement("div", { style: { maxHeight: 450 }, className: "tiny-scrollbars" },
        React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
            React.createElement(SearchInput, { name: "search", value: searchString, css: { flexGrow: 1 }, placeholder: "Search", onChange: function (e) { return onSearchHandler(e.target.value); } }),
            searchString.length ? (React.createElement("div", { style: {
                    marginLeft: 10,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                } },
                React.createElement(IoMdClose, { cursor: "pointer", onClick: function () { return onSearchHandler(''); } }))) : null),
        React.createElement("hr", null),
        React.createElement("div", { className: "columns-wrapper" },
            React.createElement("div", { className: "row-wrapper" },
                React.createElement("div", { className: "column-wrapper" },
                    React.createElement("h5", { className: "column-header" }, L('Tag'))),
                React.createElement("div", { className: "column-wrapper" },
                    React.createElement("h5", { className: "column-header" }, L('Action'))))),
        React.createElement("hr", null),
        React.createElement("div", { className: "columns-wrapper" },
            React.createElement(FixedSizeList, { height: 179, itemCount: filteredTags.length, itemSize: 37, width: 440 }, renderRow))));
}
function TagConnectionModal(_a) {
    var targetRow = _a.targetRow;
    var L = useLanguage().L;
    var _b = __read(useState(false), 2), loading = _b[0], setLoading = _b[1];
    return (React.createElement(Modal, { height: "600", width: "500", closeable: false },
        React.createElement(ModalHeader, { title: "".concat(L('Manage connections for'), " ").concat(targetRow.name) }),
        React.createElement(ModalBody, null,
            React.createElement(TagConnectionModalForm, { targetRow: targetRow, setLoading: setLoading })),
        React.createElement(ModalFooterStyled, null,
            loading && (React.createElement(AiOutlineLoading, { size: 20, style: {
                    alignSelf: 'center',
                    animation: 'spinicon 1s linear infinite',
                    position: 'absolute',
                    left: 30,
                } })),
            React.createElement(FSButton, { "$type": "tertiary", title: "Close", onClick: Manager.closeModal }))));
}
export function getGenericUniqueTagName(tagmap, tagType) {
    if (tagType === void 0) { tagType = 'Tag'; }
    var s = "New ".concat(tagType);
    var sLowerCase = s.toLowerCase();
    if (!tagmap[sLowerCase]) {
        return s;
    }
    var idx = 1;
    while (tagmap["".concat(sLowerCase, " ").concat(idx)]) {
        idx++;
    }
    return "".concat(s, " ").concat(idx);
}
export function createHeaderMenuItems(column, L, renameHandler, addColumn, removeCustomColumn, removeConnection) {
    var _this = this;
    if (column.type === TagEditorColumnType.Custom) {
        return [
            {
                icon: FarseerIcons.Edit,
                actionName: L('Rename'),
                action: renameHandler,
            },
            { spacer: true },
            {
                icon: FarseerIcons.Close,
                actionName: L('Remove Column'),
                destructive: true,
                action: function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                startGlobalLoading();
                                return [4 /*yield*/, removeCustomColumn(column.uniqueId)];
                            case 1:
                                _a.sent();
                                stopGlobalLoading();
                                return [2 /*return*/];
                        }
                    });
                }); },
            },
        ];
    }
    if (column.type === TagEditorColumnType.Connection) {
        return [
            {
                icon: FarseerIcons.Close,
                actionName: L('Remove Connection'),
                destructive: true,
                action: function () { return removeConnection(column.relation.tableTagId, column.relation.connectedTableTagId); },
            },
        ];
    }
    if (column.type === TagEditorColumnType.AddNewButton) {
        return [
            {
                icon: FarseerIcons.Connection,
                actionName: L('Table Connection'),
                creative: true,
                action: function () { return addColumn(TagEditorColumnType.Connection); },
            },
            { spacer: true },
            {
                icon: customColumnIconMap[CustomColumnType.TEXT],
                actionName: L('Text'),
                action: function () {
                    return addColumn(TagEditorColumnType.Custom, {
                        name: L('New Text Column'),
                        type: CustomColumnType.TEXT,
                    });
                },
            },
            {
                icon: customColumnIconMap[CustomColumnType.NUMBER],
                actionName: L('Number'),
                action: function () {
                    return addColumn(TagEditorColumnType.Custom, {
                        name: L('New Number Column'),
                        type: CustomColumnType.NUMBER,
                    });
                },
            },
            {
                icon: customColumnIconMap[CustomColumnType.FILE],
                actionName: L('File'),
                action: function () {
                    return addColumn(TagEditorColumnType.Custom, {
                        name: L('New File Column'),
                        type: CustomColumnType.FILE,
                    });
                },
            },
            {
                icon: customColumnIconMap[CustomColumnType.DATE],
                actionName: L('Date'),
                action: function () {
                    return addColumn(TagEditorColumnType.Custom, {
                        name: L('New Date Column'),
                        type: CustomColumnType.DATE,
                    });
                },
            },
        ];
    }
    return [];
}
export function createContextMenuItems(selection, filteredTagRows, tagTableColumns, fileInputRef, editTagJsonData, tagActionsMap, tagClassActions, L) {
    var _this = this;
    var _a;
    var tagRow = filteredTagRows[selection.y1];
    if (tagRow === undefined) {
        return [];
    }
    var _b = calculateTagPerms(tagClassActions, tagActionsMap, tagRow === null || tagRow === void 0 ? void 0 : tagRow.tag), canEdit = _b.canEdit, canDelete = _b.canDelete;
    var isValidSelection = selection.y1 !== -1 && selection.y1 === selection.y2 && tagRow !== undefined;
    var column = isValidSelection ? tagTableColumns[selection.x1] : undefined;
    if (column === undefined || column.type === TagEditorColumnType.AddNewButton) {
        return [];
    }
    var tagTypeName = getTagTypeName(tagRow.tag);
    if (column.type === TagEditorColumnType.Default) {
        return [
            {
                icon: FarseerIcons.Edit,
                actionName: L('Edit ' + tagTypeName),
                isDisabled: !isValidSelection || !canEdit,
                action: function () {
                    Manager.renderModal(React.createElement(TagModal, { tag: tagRow.tag }));
                },
            },
            {
                icon: FarseerIcons.Share,
                actionName: L('Share ' + tagTypeName),
                isDisabled: !isValidSelection || !canEdit,
                action: function () {
                    Manager.renderModal(React.createElement(ShareModal, { targetId: tagRow.id, entity: EntityPermissionsType.Tag }));
                },
            },
            { spacer: true },
            {
                icon: FarseerIcons.Delete,
                actionName: L('Delete'),
                isDisabled: !isValidSelection || !canDelete,
                destructive: true,
                items: [
                    {
                        icon: FarseerIcons.DeleteTagData,
                        actionName: L('Delete ' + tagTypeName + ' Data'),
                        isDisabled: !isValidSelection || !canDelete,
                        destructive: true,
                        action: function () {
                            Manager.renderModal(React.createElement(DeleteTagModal, { target: tagRow.tag, deleteType: "data" }));
                        },
                    },
                    { spacer: true },
                    {
                        icon: FarseerIcons.Delete,
                        actionName: L('Delete ' + tagTypeName),
                        isDisabled: !isValidSelection || !canDelete,
                        destructive: true,
                        action: function () {
                            Manager.renderModal(React.createElement(DeleteTagModal, { target: tagRow.tag, deleteType: "tag" }));
                        },
                    },
                ],
            },
        ];
    }
    if (column.type === TagEditorColumnType.Connection) {
        return [
            {
                icon: FarseerIcons.Connection,
                actionName: L('Edit Connections'),
                isDisabled: !isValidSelection || !canEdit,
                action: function () {
                    Manager.renderModal(React.createElement(TagConnectionModal, { targetRow: tagRow }));
                },
            },
        ];
    }
    if (column.type === TagEditorColumnType.Custom) {
        var tagJsonData_1 = (_a = tagRow.tag.jsonData) !== null && _a !== void 0 ? _a : { values: {} };
        if (!isDimensionTagJsonData(tagJsonData_1)) {
            return [];
        }
        if (column.customColumnType !== CustomColumnType.FILE) {
            return [
                {
                    icon: FarseerIcons.Delete,
                    actionName: L('Clear Field'),
                    isDisabled: !isValidSelection || !canEdit,
                    destructive: true,
                    action: function () { return __awaiter(_this, void 0, void 0, function () {
                        var newJsonData, err_1;
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _b.trys.push([0, 2, , 3]);
                                    newJsonData = __assign(__assign({}, tagJsonData_1), { values: __assign(__assign({}, tagJsonData_1.values), (_a = {}, _a[column.uniqueId] = null, _a)) });
                                    return [4 /*yield*/, editTagJsonData(tagRow.id, newJsonData)];
                                case 1:
                                    _b.sent();
                                    return [3 /*break*/, 3];
                                case 2:
                                    err_1 = _b.sent();
                                    toast.error(L('Error clearing field'));
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); },
                },
            ];
        }
        else {
            var existingValue_1 = tagJsonData_1.values[column.uniqueId];
            if (!!existingValue_1 && typeof existingValue_1 === 'object') {
                var replaceFileHandler_1 = function () { return __awaiter(_this, void 0, void 0, function () {
                    var inputElement, fileToUpload, farseerFile, newJsonData, err_2;
                    var _a;
                    var _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                inputElement = fileInputRef.current;
                                if (inputElement === null) {
                                    return [2 /*return*/];
                                }
                                fileToUpload = (_b = inputElement.files) === null || _b === void 0 ? void 0 : _b[0];
                                if (!(fileToUpload !== undefined)) return [3 /*break*/, 6];
                                _c.label = 1;
                            case 1:
                                _c.trys.push([1, 5, , 6]);
                                // remove old file
                                return [4 /*yield*/, farseerFilesApi.remove(existingValue_1.farseerFileId)];
                            case 2:
                                // remove old file
                                _c.sent();
                                return [4 /*yield*/, farseerFilesApi.create(fileToUpload, 'tag file')];
                            case 3:
                                farseerFile = _c.sent();
                                newJsonData = __assign(__assign({}, tagJsonData_1), { values: __assign(__assign({}, tagJsonData_1.values), (_a = {}, _a[column.uniqueId] = { filename: farseerFile.name, farseerFileId: farseerFile.id }, _a)) });
                                return [4 /*yield*/, editTagJsonData(tagRow.id, newJsonData)];
                            case 4:
                                _c.sent();
                                return [3 /*break*/, 6];
                            case 5:
                                err_2 = _c.sent();
                                toast.error(L('Error uploading file'));
                                return [3 /*break*/, 6];
                            case 6:
                                inputElement.removeEventListener('change', replaceFileHandler_1);
                                return [2 /*return*/];
                        }
                    });
                }); };
                return [
                    {
                        icon: FarseerIcons.Refresh,
                        actionName: L('Replace File'),
                        isDisabled: !isValidSelection || !canEdit,
                        action: function () {
                            var inputElement = fileInputRef.current;
                            if (inputElement === null) {
                                return;
                            }
                            inputElement.addEventListener('change', replaceFileHandler_1);
                            inputElement.click();
                        },
                    },
                    {
                        icon: FarseerIcons.ArrowDown,
                        actionName: L('Download File'),
                        isDisabled: !isValidSelection,
                        action: function () { return __awaiter(_this, void 0, void 0, function () {
                            var file;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, farseerFilesApi.get(existingValue_1.farseerFileId)];
                                    case 1:
                                        file = _a.sent();
                                        downloadFileViaBlob(file, existingValue_1.filename);
                                        return [2 /*return*/];
                                }
                            });
                        }); },
                    },
                    { spacer: true },
                    {
                        icon: FarseerIcons.Delete,
                        actionName: L('Delete File'),
                        isDisabled: !isValidSelection || !canEdit,
                        destructive: true,
                        action: function () { return __awaiter(_this, void 0, void 0, function () {
                            var newJsonData, err_3;
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _b.trys.push([0, 3, , 4]);
                                        // remove old file
                                        return [4 /*yield*/, farseerFilesApi.remove(existingValue_1.farseerFileId)];
                                    case 1:
                                        // remove old file
                                        _b.sent();
                                        newJsonData = __assign(__assign({}, tagJsonData_1), { values: __assign(__assign({}, tagJsonData_1.values), (_a = {}, _a[column.uniqueId] = null, _a)) });
                                        return [4 /*yield*/, editTagJsonData(tagRow.id, newJsonData)];
                                    case 2:
                                        _b.sent();
                                        return [3 /*break*/, 4];
                                    case 3:
                                        err_3 = _b.sent();
                                        toast.error(L('Error deleting file'));
                                        return [3 /*break*/, 4];
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); },
                    },
                ];
            }
            else {
                var uploadFileHandler_1 = function () { return __awaiter(_this, void 0, void 0, function () {
                    var inputElement, fileToUpload, farseerFile, newJsonData, err_4;
                    var _a;
                    var _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                inputElement = fileInputRef.current;
                                if (inputElement === null) {
                                    return [2 /*return*/];
                                }
                                fileToUpload = (_b = inputElement.files) === null || _b === void 0 ? void 0 : _b[0];
                                if (!(fileToUpload !== undefined)) return [3 /*break*/, 5];
                                _c.label = 1;
                            case 1:
                                _c.trys.push([1, 4, , 5]);
                                return [4 /*yield*/, farseerFilesApi.create(fileToUpload, 'tag file')];
                            case 2:
                                farseerFile = _c.sent();
                                newJsonData = __assign(__assign({}, tagJsonData_1), { values: __assign(__assign({}, tagJsonData_1.values), (_a = {}, _a[column.uniqueId] = { filename: farseerFile.name, farseerFileId: farseerFile.id }, _a)) });
                                return [4 /*yield*/, editTagJsonData(tagRow.id, newJsonData)];
                            case 3:
                                _c.sent();
                                return [3 /*break*/, 5];
                            case 4:
                                err_4 = _c.sent();
                                toast.error(L('Error uploading file'));
                                return [3 /*break*/, 5];
                            case 5:
                                inputElement.removeEventListener('change', uploadFileHandler_1);
                                return [2 /*return*/];
                        }
                    });
                }); };
                return [
                    {
                        icon: FarseerIcons.ArrowUp,
                        actionName: L('Upload File'),
                        isDisabled: !isValidSelection || !canEdit,
                        action: function () {
                            var inputElement = fileInputRef.current;
                            if (inputElement === null) {
                                return;
                            }
                            inputElement.addEventListener('change', uploadFileHandler_1);
                            inputElement.click();
                        },
                    },
                ];
            }
        }
    }
    return [];
}
